import Tracker from './Tracker';

const modalTracker = new Tracker('modalTracker', {
	OLD_MODAL_SERVICE: 'oldModalService',
	NEW_MODAL_SERVICE: 'newModalService'
});

export default modalTracker;
